module.exports = __webpack_public_path__ + "img/img8.2929956f.jpg";